/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrDateTimeColumn } from './igr-date-time-column';
import { DateTimeColumn } from './DateTimeColumn';
import { TypeRegistrar } from "igniteui-react-core";
var IgrDateTimeColumnModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrDateTimeColumnModule() {
    }
    IgrDateTimeColumnModule.register = function () {
        TypeRegistrar.registerCons("IgrDateTimeColumn", IgrDateTimeColumn);
        TypeRegistrar.register("DateTimeColumn", DateTimeColumn.$type);
    };
    return IgrDateTimeColumnModule;
}());
export { IgrDateTimeColumnModule };
//# sourceMappingURL=igr-date-time-column-module.js.map
